import { Module } from 'vuex'
import { ResponseUserStatus } from '@/services/loginService'
import { services } from '@/services/services'
import { RootState } from '@/store/index'

const service = services.login

export const userStateModule: Module<ResponseUserStatus, RootState> = {
  namespaced: true,

  state: (): ResponseUserStatus => {
    return {
      mustUpdatePassword: false,
      mustUpdateInitialPassword: false,
      mustLinkApi: false,
      mustSelectTenant: false,
      enableFuzokuMeisaiMenu: false,
      enableAdminMenu: false,
      enableSystemMenu: false
    }
  },

  mutations: {
    set: (state, payload: ResponseUserStatus) => {
      state.mustUpdatePassword = payload.mustUpdatePassword
      state.mustUpdateInitialPassword = payload.mustUpdateInitialPassword
      state.mustLinkApi = payload.mustLinkApi
      state.mustSelectTenant = payload.mustSelectTenant
      state.enableFuzokuMeisaiMenu = payload.enableFuzokuMeisaiMenu
      state.enableAdminMenu = payload.enableAdminMenu
      state.enableSystemMenu = payload.enableSystemMenu
    }
  },

  actions: {
    update: async (injectee) => {
      const data = await service.getUserStatus()
      injectee.commit('set', data)
    }
  }
}
